<p-breadcrumb
  [model]="[
    { label: 'Clientes', routerLink: ['/customers'] },
    { label: 'Detalhes do Cliente' }
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<p-toolbar class="mb-5 mt-5">
  <div class="w-full flex justify-between items-center">
    <div>
      <h5 class="font-bold">Detalhes do Cliente</h5>
      <p>Confira as informações</p>
    </div>
    <div class="flex justify-end gap-5 items-center">
      <p-button
        label="Voltar"
        routerLink="/customers"
        severity="secondary"
        rounded
        class="btn-secondary-outline"
      >
      </p-button>
    </div>
  </div>
</p-toolbar>

<p-tabs value="1">
  <p-tablist>
    <p-tab value="1">Sobre o Cliente</p-tab>
    <p-tab value="2">Pedidos</p-tab>
    <p-tab value="4">Meios de Pagamento</p-tab>
    <p-tab value="5">Histórico de Atividades</p-tab>
  </p-tablist>
  <p-tabpanels class="relative">
    @if(customer()){
    <p-tabpanel value="1">
      <div class="relative">
        @if(customer()) {
        <div class="space-y-5">
          <div class="flex gap-3 items-center">
            <img
              [src]="
                customer()?.profilePictureUrl ?? '/images/user-avatar.webp'
              "
              alt="user-photo"
              class="w-20 h-20 rounded-full object-cover"
            />
            <h5 class="font-bold">{{ customer()!.fullName }}</h5>
          </div>
          <h5 class="font-bold">Dados pessoais</h5>

          <div class="flex gap-7 mt-5">
            <div class="space-y-2">
              <p class="font-bold">Data de nascimento</p>
              <p>
                {{ customer()!.dateOfBirth | date : "dd/MM/yyyy" }}
              </p>
            </div>
            <div class="space-y-2">
              <p class="font-bold">País</p>
              <p>
                {{
                  getCountryDescriptionByCotryCode(customer()?.countryOfOrigin)
                }}
              </p>
            </div>
            <div class="space-y-2">
              <p class="font-bold">Identificação Nacional</p>
              <p>
                {{ nationalIdDocument }}
              </p>
            </div>
          </div>
        </div>
        <hr />
        <div>
          <h5 class="font-bold">Contato</h5>
          <div class="flex gap-7 mt-5">
            <div class="space-y-2">
              <p class="font-bold">Telefone</p>
              <p>
                {{ primaryPhone }}
              </p>
            </div>

            <div class="space-y-2">
              <p class="font-bold">E-mail</p>
              <p>
                {{ primaryEmail }}
              </p>
            </div>
          </div>
        </div>
        @if(deliveryAddress){
        <hr />
        <div>
          <h5 class="font-bold">Endereço de entrega</h5>

          <div class="flex flex-wrap gap-7 mt-5">
            <div class="space-y-2">
              <p class="font-bold">Street Address</p>
              <p>
                {{ deliveryAddress.street }}
              </p>
            </div>

            <div class="space-y-2">
              <p class="font-bold">Apt, Suite, Unit (Optional)</p>
              <p>
                {{ deliveryAddress.street }}
              </p>
            </div>

            <div class="space-y-2">
              <p class="font-bold">City</p>
              <p>
                {{ deliveryAddress.city }}
              </p>
            </div>

            <div class="space-y-2">
              <p class="font-bold">State</p>
              <p>
                {{ deliveryAddress.state }}
              </p>
            </div>

            <div class="space-y-2">
              <p class="font-bold">ZIP Code</p>
              <p>
                {{ deliveryAddress.zipCode }}
              </p>
            </div>
          </div>
        </div>
        } } @else {
        <h3 class="text-center">Cliente não encontrado.</h3>
        } @if(loading()) {
        <div
          class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
        >
          <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
        </div>
        }
      </div>
    </p-tabpanel>

    <p-tabpanel value="2">
      @if(orders()!.length === 0){
      <p class="text-center">Nenhum pedido feito até o momento</p>
      }@else{
      <h4 class="font-bold mb-6">Pedidos</h4>

      @for (order of pagedOrders(); track order.id) {
      <div class="flex flex-col">
        <div class="block w-fit">
          <app-tag-status
            [text]="getOrderStatusDescription(order.status)"
            [status]="getOrderStatusTag(order.status)"
          ></app-tag-status>
        </div>
        <div class="flex items-center gap-5 mt-4 justify-between">
          <div>
            <p>Pedido</p>
            <h5 class="font-bold mt-2">#{{ order.number }}</h5>
          </div>
          <a pButton rounded [routerLink]="'/orders/details/' + order.id">
            Ver Detalhes
          </a>
        </div>
      </div>
      <hr />
      } @if (orders()!.length > 0) {
      <div class="mt-4">
        <p-paginator
          [first]="first()"
          [rows]="rows()"
          [totalRecords]="orders().length"
          [rowsPerPageOptions]="[5, 10, 20, 50]"
          (onPageChange)="onPageChange($event)"
        />
      </div>
      } }
    </p-tabpanel>

    <p-tabpanel value="4">
      @if(customer()?.cards?.length === 0){
      <p class="text-center">
        Nenhum meio de pagamento cadastrado até o momento
      </p>
      }@else {
      <h4 class="font-bold mb-6">Meios de Pagamento</h4>

      @for(card of customer()?.cards ?? []; track card.id){
      <div
        class="border-1 border-gray-300 rounded-2xl p-5 flex gap-5 items-center mb-3"
      >
        <span
          class="ph-duotone ph-credit-card text-4xl text-purple-primary-500"
        ></span>
        <div class="flex flex-col space-y-2">
          <p class="font-bold">
            {{ card.brand | titlecase }} •••• {{ card.displayNumber }}
          </p>
          <p class="text-gray-500">
            Expira em {{ formatCardExpirationDate(card) }}
          </p>
        </div>
      </div>

      } }
    </p-tabpanel>

    <p-tabpanel value="5">
      <h4 class="font-bold mb-6">Histórico de Atividades</h4>

      @for(stage of customer()?.stageHistories ?? []; track stage.id){
      <div class="flex gap-5 items-center mb-3">
        <div class="flex flex-col gap-2">
          <div class="flex gap-5">
            <p class="font-bold">
              {{ getRegistrationStageDescription(stage.to) }}
            </p>
          </div>
          <p class="text-sm">
            {{ stage.transitionedAt | date : "dd '/' MMM '/' yyyy 'às' HH:mm" }}
          </p>
        </div>
      </div>
      }
    </p-tabpanel>
    }@else {
    <p class="text-center">Nenhum dado encontrado</p>
    } @if(loading()) {
    <div
      class="absolute inset-0 z-10 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
    >
      <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
    </div>
    }
  </p-tabpanels>
</p-tabs>

<p-toast />
